// require('eruda').init()

import os from '@edu-fe/os' // eslint-disable-line
import App from './App.vue' // eslint-disable-line
import {
  createRouter
} from './router' // eslint-disable-line

import store from './store' // eslint-disable-line
import './polyfill' // eslint-disable-line
import InitShare from './lib/initShare' // eslint-disable-line

import rem from '@edu-fe/rem' // eslint-disable-line
import Loading from '@edu-fe/vue-loading' // eslint-disable-line
import Toast from '@edu-fe/vue-toast' // eslint-disable-line
import ShareCover from '@edu-fe/share-cover' // eslint-disable-line
import Dialog from '@edu-fe/modal' // eslint-disable-line

import {
  sync
} from 'vuex-router-sync' // eslint-disable-line
import global from './types/global.types' // eslint-disable-line
import axios from 'axios'
import queryString from '@/utils/queryString'
// 上拉加载下拉刷新组件
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)
// import fundebugVue from 'fundebug-vue'
//
// fundebug.apikey = '22100c88a3e949215869ee12f63b51330b88bc3a350c4757cd791cb1a3b999df'
// fundebugVue(fundebug, Vue)

import './lib/api' // eslint-disable-line
import Login from '@/utils/login'
import Cookie from 'js-cookie'
import './utils/iconfont'

rem.set({
  designWidth: 750,
  maxWidthPx: Math.min(window.innerWidth, 480)
})

Vue.use(new Toast())
Vue.use(ShareCover)
Vue.use(Loading)
Vue.use(VueAwesomeSwiper)
Vue.use(Dialog)
Vue.config.productionTip = false
axios.defaults.withCredentials = true
Vue.prototype.$axios = axios
// 用于 webpack 在主文件载入 async generator
export async function init(options) {
  // 初始设置标题为空
  document.title = ''
  const router = createRouter({
    baseUrl: options.baseUrl
  })
  let appIdInBrowser = window.localStorage.getItem('wkAppId')
  let appId = queryString().appId

  // 同步router到store
  sync(store, router)

  // 网易七鱼客服初始化
  const query = window.location.search

  // 分享初始化
  InitShare._init()
  router.afterEach(route => {
    if (!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      InitShare._init()
    }
  })

  // 不同机构重新授权
  let hasAppid = appId && appId != appIdInBrowser
  await axios.get(`https://chenxidaily.auoktalk.com/api/user/openid/match?appId=${appId}`).then( async res => {
    const { data: { data } } = res
    // 如果当前appid存在且当前的appid和本地存储appid不相等  删除openid重新授权
    if ((hasAppid || data == 0) && os.type == 'weixin') {
      // 清除用户授权
      await axios.get(`https://chenxidaily.auoktalk.com/api/chenxi/platform/clear/cookie?appIdInBrowser=${appIdInBrowser}&appId=${appId}`).then(res => {
        // 重新授权
        Login.login()
        Cookie.remove('openid')
      }).catch(() => {
        // 重新授权
        Login.login()
        Cookie.remove('openid')
      })
    }
    // 如果当前appid不存在 或=undefined 或者是当前地址栏appid和我存储的不相等  然后就重新存入appid
    if (!appIdInBrowser || appIdInBrowser == '' || appIdInBrowser == 'undefined' || data == 0 || hasAppid) {
      window.localStorage.setItem('wkAppId', appId || 'wx6b484745cf587ac3')
    }
    // 获取当前机构信息
    await axios.get(`https://chenxidaily.auoktalk.com/api/chenxi/platform/organization/info`, {
      headers: {
        'third-appid': window.localStorage.getItem('wkAppId') || appId
      }
    }).then (res => {
      const { data: { data } } = res
      document.title = data ? data.organName : ''
      store.state.organizationMessage = data
    })
  })
  // 实例化
  new Vue({
    router,
    store,
    render: h => h(App),

    beforeCreate() {
      this.$store.commit(global.SET_LAUNCH_OPTIONS, this.$route.query)
    },

    created() {
      this.$store.dispatch('getPopupData')
    }
  }).$mount('#app')
}
